// components/LanguageSwitcher.jsx
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
   
    localStorage.setItem("lang", newLang);
    i18n.changeLanguage(newLang).then(() => {
      document.documentElement.lang = newLang;
      document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
    });
   window.location.href=""
  };

  // Initialize direction on first load
  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, []);

  return (
    <button onClick={toggleLanguage}>
      {i18n.language === "en" ? "العربية" : "English"}
    </button>
  );
};

export default LanguageSwitcher;
